import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/insc`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/jntinsc`,
};

export const URLS = {
    osci0301001q: `${BASE.path}/osci0301001q`, // List Joint Inspection Booking          !== 합동 검사 예약 목록 화면 ==!
    osci0301002s: `${BASE.path}/osci0301002s`, // Details Joint Inspection Booking       !== 합동 검사 예약 상세 화면 ==!
    osci0301003s: `${BASE.path}/osci0301003s`, // Registration Joint Inspection Booking Result  !== 합동 검사 예약 결과 등록 화면 ==!
    eswo0105009q: `${BASE.path}/eswo0105009q`, // Joint Inspection Result Search          !== 합동 검사 결과 조회 화면 ==!
};

export const APIS = {
    // Search the Joint Inspection Booking list. !== 합동검사 예약 목록을 조회한다. ==!
    getJntInscBkngList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/bkng?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Search the Joint Inspection Booking detail. !== 합동검사 예약 상세정보를 조회한다. ==!
    getJntInscBkngDtl: (tansadNo: any) => {
        return api.get(`${BASE.api}/bkng/${tansadNo}`);
    },

    // Get Joint Inspection Result List !== 합동검사 결과 목록 조회 ==!
    getJntInspRsltList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/app-rslt-list?page=${page}&size=${size}`, {
            params: data,
        });
    },

    getInscAtcmList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/insc-atcm-list?page=${page}&size=${size}`, {
            params: data,
        });
    },

    getJntInscPrcsHistList: (tansadNo: any) => {
        return api.get(`${BASE.api}/aprv-hist/${tansadNo}`);
    },

    // Get Application Approval Information !== 신청서 승인 정보 조회 ==!
    getBkngAppAprvInfo: (data: any) => {
        return api.get(`${BASE.api}/app-aprv-info`, { params: data });
    },

    // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
    updateReceived: (tansadNo: any, prcsStatCd: any) => {
        return api.put(`${BASE.api}/rcve/${tansadNo}`, { prcsStatCd: prcsStatCd });
    },

    // Save Registering audit results !== 심사/승인 결과 등록 ==!
    saveBkngAppAprvRslt: (data: any) => {
        return api.post(`${BASE.api}/app-aprv-save`, {
            ...data,
        });
    },
    // Submit Application Approval Result !== 신청서 승인 정보 제출 ==!
    sbmtBkngAppAprvRslt: (data: any) => {
        return api.post(`${BASE.api}/app-aprv-sbmt`, { ...data });
    },

    // Approval Result Code Exclusion List!== 승인 결과 코드 제외 목록 ==!
    getExcludeAuditRsltCdList: (prcsRoleTpCd: string, prevPrcsRoleTpCd: string) => {
        const arrExcludeDefault = ["VF", "IP", "AP", "RS", "RJ"];
        const excludeVerifMap: { [key: string]: string[] } = {
            VE: ["VF", "IP", "AP", "CF", "NC", "NR", "IF", "CR"],
            FR: ["VF", "IP", "AP", "CF", "NC", "NR", "IF", "CR"],
            IP: ["VF", "FV", "RE", "AP", "CF", "NC", "NR", "IF", "CR"],
            IA: ["VF", "FV", "RE", "RJ", "RS", "NR", "IF", "CR"],
        };
        let arrExcludes = [...(excludeVerifMap[prcsRoleTpCd] || arrExcludeDefault)];
        if (prevPrcsRoleTpCd == "SU") {
            arrExcludes.push("RE"); // RETURN
        } else {
            arrExcludes.push("RS"); // RE-SUBMIT
        }

        // Fee payment result is recorded by system only !== 수수료납부완료는 시스템만 기록 ==!
        arrExcludes.push("PA");

        return arrExcludes;
    },
};

export const SF_SCHEMA_BKNG_SRCH_FORM: TFormSchema = {
    id: "form_booking_search",
    schema: {
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
        } /* TANSAD No !== TANSAD 번호 ==! */,
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 4,
        } /* Customs Office Code !== 세관 사무소 코드 ==! */,
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            imemode: "number",
            maxLength: 2,
        } /* TANSAD Year !== TANSAD 년도 ==! */,
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            imemode: "number",
            maxLength: 7,
        } /* TANSAD Serial Number !== TANSAD 일련번호 ==! */,
        reffNo: {
            label: "L_REFF_NO",
            controlSize: 2,
        } /* Reference Number !== 참조 번호 ==! */,
        reffTin: {
            type: "text",
            controlSize: 1,
            maxLength: 9,
            imemode: "number",
            // disabled: true,
        } /* Reference TIN !== 참조 TIN ==! */,
        reffYy: {
            type: "text",
            controlSize: 1,
            maxLength: 2,
            imemode: "number",
        } /* Reference Year !== 참조 년도 ==! */,
        reffSrno: {
            type: "text",
            controlSize: 1,
            maxLength: 7,
            imemode: "number",
        } /* Reference Serial Number !== 참조 일련 번호 ==! */,
        srchDt: {
            type: "daterange",
            label: "L_DT",
            start: { name: "srchDtStrt" },
            end: { name: "srchDtEnd" },
        } /* Search Date !== 검색 일자 ==! */,
        srchStatCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0165",
            label: "L_STAT",
            all: true,
            excludes: ["C", "D", "F", "G", "H"],
        } /* Status !== 상태 ==! */,
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
            maxLength: 35,
        } /* UCR No !== UCR 번호 ==! */,
    },
};

export const SF_SCHEMA_INSC_BKNG_FORM: TFormSchema = {
    id: "form_insc_bkng",
    schema: {
        tansadNo: {
            type: "text",
            label: "L_TANSAD_NO",
            required: true,
            edit: true,
        } /* TANSAD No !== TANSAD 번호 ==!*/,
        reffNo: {
            type: "text",
            label: "L_REFF_NO",
            required: true,
            edit: true,
        } /* Reference No. !== 참조 번호 ==!*/,
        blAwbNo: {
            type: "text",
            label: "L_BL_AWB_NO",
            required: true,
            edit: true,
        } /* BL/AWB No. !== BL/AWB 번호 ==!*/,
        bkngDt: {
            type: "date",
            label: "L_BOOK_DT",
            required: true,
            edit: true,
        } /* Booked Date !== 예약일자 ==!*/,
        godsLoctWrhsCd: {
            type: "code",
            area: "wrhsCd",
            label: "L_CAG_DPST_STN",
            required: true,
        } /* Cargo Keeper Station !== 화물보관소 ==!*/,
        cntrLstCn: {
            type: "select",
            label: "L_CAG_TP",
            required: true,
            edit: true,
            options: [
                { label: "L_VHCL", value: "VEHICLE" },
                { label: "L_BULK", value: "BULK" },
                { label: "L_LOOSE_CAG", value: "LOOSE" },
                { label: "L_FCL", value: "FCL" },
                { label: "L_LCL", value: "LCL" },
            ],
        } /* Cargo Type !== 화물 구분 ==!*/,
        inscZone: {
            type: "select",
            label: "L_INSC_ZONE",
            edit: true,
        } /* Inspection Zone !== 검사구역 ==!*/,
    },
};

export const SF_SCHEMA_INSC_FORM: TFormSchema = {
    id: "form_insc",
    schema: {
        appId: {
            controlSize: 2,
            type: "text",
            edit: false,
        } /* LPCO APP UUID ==!*/,
        appNo: {
            label: "L_APP_NO",
            controlSize: 2,
        } /* LPCO APP NO ==!*/,
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
            edit: false,
        } /* UCR No !== UCR 번호 ==! */,
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
        } /* TANSAD No !== TANSAD 번호 ==!*/,
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* Customs Office Code !== 세관 사무소 코드 ==! */,
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Year !== TANSAD 년도 ==! */,
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Serial Number !== TANSAD 일련번호 ==! */,
        reffNo: {
            label: "L_REFF_NO",
            controlSize: 2,
            edit: false,
        } /* Reference Number !== 참조 번호 ==! */,
        reffTin: {
            type: "text",
            controlSize: 1,
            maxLength: 9,
            imemode: "number",
            edit: false,
        } /* Reference TIN !== 참조 TIN ==! */,
        reffYy: {
            type: "text",
            controlSize: 1,
            maxLength: 2,
            imemode: "number",
            edit: false,
        } /* Reference Year !== 참조 년도 ==! */,
        reffSrno: {
            type: "text",
            controlSize: 1,
            maxLength: 7,
            imemode: "number",
            edit: false,
        } /* Reference Serial Number !== 참조 일련 번호 ==! */,
        prcsStat: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0165",
            label: "L_STAT",
            edit: false,
        } /* Status !== 상태 ==! */,
        prcsStatCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0165",
            label: "L_STAT",
            edit: false,
        } /* Status !== 처리_상태_코드 ==! */,
        godsLoctWrhsCd: {
            type: "code",
            area: "wrhsCd",
            label: "L_LOCT_GODS",
            edit: false,
        } /* Location of Goods !== 물품 위치 ==! */,
        bkngRqstDt: {
            type: "date",
            label: "L_BKNG_RQST_DT",
            edit: false,
        } /* Booking Request Date !== 예약 요청 일자 ==! */,
        apvrNm: {
            type: "text",
            label: "L_APVR",
            edit: false,
        } /* Approved By !== 승인자 ==! */,
        aprvDt: {
            type: "datetime",
            label: "L_APRV_DT",
            edit: false,
        } /* Approval Date !== 승인 일자 ==! */,
        bkngCfrmDtm: {
            type: "datetime",
            label: "L_BKNG_APRV_DT",
            edit: false,
        } /* Booking Approval Date !== 예약 승인 일자 ==! */,
        inscCfrmDt: {
            type: "datetime",
            label: "L_INSC_CFRM_DT",
            edit: false,
        } /* Inspection Confirmation Date !== 검사 확인 일자 ==! */,
        cntrCnt: {
            type: "number",
            label: "L_CNTR_CNT",
            edit: false,
        } /* Container Count !== 컨테이너 개수 ==! */,
        cntrLstCn: {
            type: "text",
            label: "L_CNTR_LST",
            edit: false,
        } /* Container List Count !== 컨테이너 목록 ==! */,
        jntInscZoneAddr: {
            type: "textarea",
            label: "L_INSC_ZONE",
            edit: false,
        } /* Inspection Zone !== 검사구역 ==! */,
        blNo: {
            type: "text",
            label: "L_BL_NO",
            edit: false,
        } /* BL No !== BL 번호 ==! */,
        bkngMdfyRqstDt: {
            type: "date",
            label: "L_BKNG_MDFY_DT",
            edit: false,
        } /* Booking Modify Request Date !== 예약 변경 일자 ==! */,
    },
};

export const SF_SCHEMA_TANSAD_FORM: TFormSchema = {
    id: "form_tansad",
    schema: {
        decMode: {
            type: "select",
            label: "L_DCLR_MODE_CD",
            area: "comnCd",
            comnCd: "OSC0042",
            viewType: "both",
            editType: "both",
        } /* TANSAD Regime !== TANSAD 레짐 ==! */,
        sltvRsltCd: {
            type: "select",
            label: "L_SLTV_RSLT",
            area: "comnCd",
            comnCd: "OSC0033",
            viewType: "both",
            editType: "both",
        } /* Selectivity Result !== 선별 결과 ==! */,
        tin: {
            type: "text",
            label: "L_IMPPN_EXPPN",
            mask: MASK.TIN,
        } /* Importer/Exporter !== 수출입업자 ==! */,
        dcltTin: {
            type: "text",
            label: "L_DCLT",
            edit: false,
            mask: MASK.TIN,
        } /* Declarant !== 신고인 ==! */,
        crn: {
            type: "text",
            label: "L_CRN",
            mask: MASK.CRN,
        } /* CRN !== 화물참조번호 ==! */,
        godsLoctReffCn: {
            type: "code",
            area: "wrhsCd",
            label: "L_LOCT_GODS",
            edit: false,
        } /* Location of Goods !== 물품 위치 ==! */,
    },
};

export const SF_RGST_VRFN_RSLT: TFormSchema = {
    id: "form_rgst_vrfn_rslt",
    schema: {
        asnmtId: {
            type: "text",
            edit: false,
        } /* Assignment Universally Unique Identifier !== 배정_UUID ==!*/,
        reffId: {
            type: "text",
            edit: false,
        } /* Reference Universally Unique Identifier !== 참고_UUID ==!*/,
        prcssStatCd: {
            type: "select",
            label: "L_INSC_RSLT",
            area: "comnCd",
            comnCd: "OSC0131",
            required: true,
            edit: true,
        } /* Verification Result !== 조회용 심사결과 ==!*/,
        prcssRsnCn: {
            type: "textarea",
            label: "L_INSC_RSN",
            required: true,
            edit: true,
        } /* Verification Reason !== 조회용 심사결과이유 ==!*/,
        rmrk: { type: "textarea", label: "L_INSC_RMRK", edit: true } /* Remark !== 입력용 Remark ==!*/,
        exmpnTaxTpCd: {
            type: "checkbox",
            label: "L_EXMPN_TAX_TP",
            area: "comnCd",
            comnCd: "OSC0142",
            required: true,
            edit: true,
        } /* Verification Result !== 조회용 심사결과 ==!*/,
    },
};

export const SG_GRID_INSC_BKNG_LIST: TGridSchema = {
    id: "grid_inscBkngList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*" }], id: "tansadNo" },
        { cells: [{ header: "L_REFF_NO", binding: "reffNo", width: "*" }], id: "reffNo" },
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: 250 }], id: "ucrNo" },
        { cells: [{ header: "L_CAG_TP", binding: "cntrLstCn", width: 110 }], id: "cntrLstCn" },
        { cells: [{ header: "L_BKNG_RQST_DT", binding: "bkngRqstDt", width: "*" }], id: "bkngRqstDt" },
        { cells: [{ header: "L_BKNG_APRV_DT", binding: "bkngCfrmDtm", width: "*" }], id: "bkngCfrmDtm" },
        { cells: [{ header: "L_APRV_DT", binding: "aprvDtm", width: "*" }], id: "aprvDtm" },
        { cells: [{ header: "L_INSC_CFRM_DT", binding: "inscCfrmDtm", width: "*" }], id: "inscCfrmDtm" },
        { cells: [{ header: "L_ASNMT_OFCR", binding: "asnmtOfcrId", width: 150 }] } /* Assigned Officer */,
        { cells: [{ header: "L_STAT", binding: "prcsStatCd", width: 110 }], id: "prcsStatCd" },
    ],
    body: [
        {
            cells: [{ binding: "tansadNo", mask: MASK.TANSAD_NO }] /* TANSAD No !== TANSAD 번호 ==! */,
        },
        {
            cells: [{ binding: "reffNo", mask: MASK.REFF_NO }] /* Reference No !== 참조 번호 ==! */,
        },
        {
            cells: [{ binding: "ucrNo" }] /* UCR No !== UCR 번호 ==! */,
        },
        {
            cells: [{ binding: "cntrLstCn" }] /* Cargo Type !== 화물 구분 ==! */,
        },
        {
            cells: [
                { binding: "bkngRqstDt", edit: false, type: "date" },
            ] /* Booking Request Date !== 예약 요청 일자 ==! */,
        },
        {
            cells: [
                { binding: "bkngCfrmDtm", edit: false, type: "datetime" },
            ] /* Booking Approval Date !== 예약 승인 일자 ==! */,
        },
        {
            cells: [{ binding: "aprvDtm", edit: false, type: "datetime" }] /* Approval Date !== 승인 일자 ==! */,
        },
        {
            cells: [
                { binding: "inscCfrmDtm", edit: false, type: "datetime" },
            ] /* Inspection Confirmation Date !== 검사 확인 일자 ==! */,
        },
        {
            cells: [{ binding: "asnmtOfcrId" }] /* Status !== 상태 ==! */,
        },
        {
            cells: [
                { binding: "prcsStatCd", type: "code", area: "comnCd", comnCd: "OSC0165" },
            ] /* Status !== 상태 ==! */,
        },
    ],
};

export const SG_GRID_SLTV_CTRA_LIST: TGridSchema = {
    id: "grid_sltvCtraList",
    options: { height: "auto", radio: false, checkbox: false, index: true, edit: false },
    head: [
        { cells: [{ header: "L_ITM_NO", binding: "itmNo", width: "*" }], id: "itmNo" },
        { cells: [{ header: "L_CTRA_RGSR_NO", binding: "ctraRgsrNo", width: "*" }], id: "ctraRgsrNo" },
        { cells: [{ header: "L_SLTV_RSLT", binding: "sltvRslt", width: "*" }], id: "sltvRslt" },
        { cells: [{ header: "L_INSC_GDLN", binding: "inscGdln", width: "*" }], id: "inscGdln" },
    ],
    body: [
        {
            cells: [{ binding: "itmNo" }] /* Item No !== 품목 번호 ==! */,
        },
        {
            cells: [{ binding: "ctraRgsrNo" }] /* Criteria Registration Number !== 기준 등록 번호 ==! */,
        },
        {
            cells: [{ binding: "sltvRslt" }] /* Selectivity Result !== 선별 결과 ==! */,
        },
        {
            cells: [{ binding: "inscGdln" }] /* Inspection Guideline !== 검사 지침 ==! */,
        },
    ],
};

export const SG_GRID_SLTV_CTRA_CHG_LIST: TGridSchema = {
    id: "grid_sltvCtraChgList",
    options: { height: "auto", radio: false, checkbox: false, index: true, edit: false },
    head: [
        { cells: [{ header: "L_RGSR_DT", binding: "sltvRsltChgDtm", width: "*" }], id: "sltvRsltChgDtm" },
        { cells: [{ header: "L_RGSR_OFCR_ID", binding: "sltvChgOfcrNm", width: "*" }], id: "sltvChgOfcrNm" },
        { cells: [{ header: "L_BF_SLTV_RSLT_CD", binding: "chgBfSltvRsltCd", width: "*" }], id: "chgBfSltvRsltCd" },
        { cells: [{ header: "L_AF_SLTV_RSLT_CD", binding: "chgAfSltvRsltCd", width: "*" }], id: "chgAfSltvRsltCd" },
        { cells: [{ header: "L_RMRK", binding: "sltvChgRmrk", width: "*" }], id: "sltvChgRmrk" },
    ],
    body: [
        {
            cells: [{ binding: "sltvRsltChgDtm" }] /* Registration Date !== 등록 일자 ==! */,
        },
        {
            cells: [{ binding: "sltvChgOfcrNm" }] /* Registered by !== 등록 직원 ID ==! */,
        },
        {
            cells: [{ binding: "chgBfSltvRsltCd" }] /* Current Selectivity Result !== 현재 선별 결과 코드 ==! */,
        },
        {
            cells: [{ binding: "chgAfSltvRsltCd" }] /* After Selectivity Result !== 이후 선별 결과 코드 ==! */,
        },
        {
            cells: [{ binding: "sltvChgRmrk" }] /* Remarks !== 비고 ==! */,
        },
    ],
};

export const SG_GRID_SLTV_ITM_LIST: TGridSchema = {
    id: "grid_sltvItmList",
    options: { pagination: "in", height: "auto" },
    head: [
        { cells: [{ header: "L_NO", binding: "itmNo", width: "*" }], id: "itmNo" },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "*" }], id: "hsCd" },
        { cells: [{ header: "L_PROD_NM", binding: "hsDesc", width: "*" }], id: "hsDesc" },
        { cells: [{ header: "L_CNTY_ORIG", binding: "origCntyCd", width: "*" }], id: "origCntyCd" },
        { cells: [{ header: "L_MDFY_HS_CD", binding: "mdfyHsCd", width: "*" }], id: "mdfyHsCd" },
        { cells: [{ header: "L_MDFY_CNTY_ORIG", binding: "mdfyOrigCntyCd", width: "*" }], id: "mdfyOrigCntyCd" },
        { cells: [{ header: "L_DTCN_YN", binding: "dtcnYn", width: "*" }], id: "dtcnYn" },
    ],
    body: [
        {
            cells: [{ binding: "itmNo" }] /* Item Number !== 품목_순번 ==! */,
        },
        {
            cells: [{ binding: "hsCd" }] /* HS Code !== 세번부호 ==! */,
        },
        {
            cells: [{ binding: "hsDesc" }] /* Product Name !== 제품명 ==! */,
        },
        {
            cells: [{ binding: "origCntyCd" }] /* Country of Origin !== 원산지 ==! */,
        },
        {
            cells: [{ binding: "mdfyHsCd" }] /* Modified HS Code !== 수정된 HS 코드 ==! */,
        },
        {
            cells: [{ binding: "mdfyOrigCntyCd" }] /* Modified Country of Origin !== 수정된 원산지 ==! */,
        },
        {
            cells: [{ binding: "dtcnYn" }] /* Detection Y/N !== 감지 여부 ==! */,
        },
    ],
};

export const SG_GRID_MBL_HBL_LIST: TGridSchema = {
    id: "grid_mblHblList",
    options: { height: "auto" },
    head: [{ cells: [{ header: "L_CNTR_NO", binding: "cntrNo", width: "*" }], id: "cntrNo" }],
    body: [
        {
            cells: [{ binding: "cntrNo" }] /* Container Number !== 컨테이너_번호 ==! */,
        },
    ],
};

export const SG_GRID_CNTR_LIST: TGridSchema = {
    id: "grid_cntrList",
    options: { height: "auto", index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_CNTR_NO", binding: "cntr_no", width: "*" }], id: "cntr_no" },
        { cells: [{ header: "L_LOAD_TP", binding: "load_tp_cd", width: "*" }], id: "load_tp_cd" },
        { cells: [{ header: "L_CNTR_SIZE", binding: "cntr_size_cd", width: "*" }], id: "cntr_size_cd" },
        { cells: [{ header: "L_SEAL_1", binding: "seal_no_1", width: "*" }], id: "seal_no_1" },
        { cells: [{ header: "L_SEAL_2", binding: "seal_no_2", width: "*" }], id: "seal_no_2" },
        { cells: [{ header: "L_SEAL_3", binding: "seal_no_3", width: "*" }], id: "seal_no_3" },
        { cells: [{ header: "L_FRGH_IDCR", binding: "frgh_idcr_cd", width: "*" }], id: "frgh_idcr_cd" },
        { cells: [{ header: "L_PCKG_UT", binding: "pckg_ut_cd", width: "*" }], id: "pckg_ut_cd" },
        { cells: [{ header: "L_CNTR_WGHT", binding: "cntr_wght", width: "*" }], id: "cntr_wght" },
        { cells: [{ header: "L_WGHT_UT", binding: "wght_ut_cd", width: "*" }], id: "WGHTwght_ut_cdUT_CD" },
    ],
    body: [
        {
            cells: [{ binding: "cntr_no" }] /* Container Number !== 컨테이너_번호 ==! */,
        },
        {
            cells: [
                { binding: "cntr_size_cd", type: "code", area: "OSC0004" },
            ] /* Continer Size Code !== 컨테이너_크기_코드 ==! */,
        },
        {
            cells: [
                { binding: "load_tp_cd", type: "code", area: "OSC0006" },
            ] /* Loading Type Code !== 적재_유형_코드 ==! */,
        },
        {
            cells: [{ binding: "seal_no_1" }] /* Seal Number 1 !== 봉인_번호_1 ==! */,
        },
        {
            cells: [{ binding: "seal_no_2" }] /* Seal Number 2 !== 봉인_번호_2 ==! */,
        },
        {
            cells: [{ binding: "seal_no_3" }] /* Seal Number 3 !== 봉인_번호_3 ==! */,
        },
        {
            cells: [
                { binding: "frgh_idcr_cd", type: "code", area: "OSC0005" },
            ] /* Freight Indicator Code !== 운임_지표_코드 ==! */,
        },
        {
            cells: [
                { binding: "pckg_ut_cd", type: "code", area: "OSC0080" },
            ] /* Package Unit Code !== 포장_단위_코드 ==! */,
        },
        {
            cells: [{ binding: "cntr_wght", type: "number" }] /* Container Weight !== 컨테이너_중량 ==! */,
        },
        {
            cells: [{ binding: "wght_ut_cd" }] /* Weight Unit Code !== 중량_단위_코드 ==! */,
        },
    ],
};

export const SG_GRID_INSC_RPRT_LIST: TGridSchema = {
    id: "grid_inscRprtList",
    options: { pagination: "in", edit: true, checkbox: false, radio: false, index: true, height: 300 },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_STTS", binding: "prcssStatCd", width: "*" }], id: "prcssStatCd" },
        { cells: [{ header: "L_PRCSS_STAT", binding: "asnmtOfcrTpNm", width: "*" }], id: "asnmtOfcrTpNm" },
        { cells: [{ header: "L_INSC_RPRT", binding: "inscRprt", width: "*" }], id: "inscRprt" },
        { cells: [{ header: "L_PRCS_DT", binding: "prcssDtm", width: "*" }], id: "prcssDtm" },
        { colspan: 2, cells: [{ header: "L_CNNT", binding: "cnnt", width: "*", colspan: 2 }], id: "cnnt" },
    ],

    body: [
        {
            cells: [{ binding: "orgNm", type: "text", align: "left", rowspan: 2 }],
        },
        {
            cells: [
                {
                    binding: "prcssStatNm",
                    align: "center",
                    type: "text",
                    rowspan: 2,
                },
            ],
        },
        {
            cells: [{ binding: "asnmtOfcrTpNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "inscRprt", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "prcssDtm", type: "datetime", align: "center", rowspan: 2 }],
        },
        {
            colspan: 2,
            cells: [
                { binding: "prcssCnNm", type: "text", align: "left" },
                { binding: "prcssCn", type: "text", align: "left" },
                { binding: "aprvRmrk", type: "text", align: "left" },
                { binding: "rmrk", type: "text", align: "left" },
            ],
        },
    ],
};

export const SG_GRID_INSC_ATCM_LIST: TGridSchema = {
    id: "grid_inscAtcmList",
    options: { pagination: "in", edit: true, checkbox: true, radio: false, index: true, height: 300 },
    head: [
        { cells: [{ header: "L_DOC_TP", binding: "atcmTpCd", width: 300 }] } /* Document Type !== 문서타입 ==!*/,
        { cells: [{ header: "L_ATCD_FILE", binding: "atchFile", width: "*" }] } /* Attached File !== 첨부파일 ==!*/,
    ],
    body: [
        {
            cells: [
                {
                    binding: "atcmTpCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0025",
                    popupSize: "lg",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "atchFile",
                    type: "file",
                    align: "left",
                    bsopClsfCd: "OSC",
                    mode: "edit",
                    required: true,
                },
            ],
        },
    ],
};

// Read-only variant for viewing a previously registered inspection result's attachments !== 기 등록된 검사 결과 첨부파일 조회용(읽기전용) ==!
export const SG_GRID_INSC_ATCM_VIEW_LIST: TGridSchema = {
    id: "grid_inscAtcmViewList",
    options: { pagination: "in", edit: false, checkbox: false, radio: false, index: true, height: 300 },
    head: [
        { cells: [{ header: "L_DOC_TP", binding: "atcmTpCd", width: 300 }] },
        { cells: [{ header: "L_ATCD_FILE", binding: "atchFile", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "atcmTpCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0025",
                    viewType: "label",
                    edit: false,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "atchFile",
                    type: "file",
                    align: "left",
                    bsopClsfCd: "OSC",
                    edit: false,
                },
            ],
        },
    ],
};

export const SG_GRID_INSC_RSLT_LIST: TGridSchema = {
    id: "grid_inscRsltList",
    options: { pagination: "in", edit: false, checkbox: false, radio: false, index: false, height: 300 },
    head: [
        { cells: [{ header: "L_OGA", binding: "oga", width: "*" }], id: "oga" },
        { cells: [{ header: "L_STTS", binding: "stts", width: "*" }], id: "stts" },
        { cells: [{ header: "L_CMNTS", binding: "cmnts", width: "*" }], id: "cmnts" },
        { cells: [{ header: "L_ATCTMS", binding: "atctms", width: "*" }], id: "atctms" },
    ],
    body: [
        {
            cells: [{ binding: "oga" }] /* OGA !== 기관 ==!*/,
        },
        {
            cells: [{ binding: "stts" }] /* Status !== 상태 ==!*/,
        },
        {
            cells: [{ binding: "cmnts" }] /* Comments !== 코멘트 ==!*/,
        },
        {
            cells: [{ binding: "atctms" }] /* Attachments !== 첨부파일 ==!*/,
        },
    ],
};

export const SG_GRID_JNT_INSC_APRV_LIST: TGridSchema = {
    id: "grid_aprvList",
    options: {
        pagination: "in",
        edit: false,
        checkbox: false,
        radio: false,
        index: "DESC",
    },
    head: [
        { cells: [{ header: "L_TRGT", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_STTS", binding: "prcssStatCd", width: "*" }], id: "prcssStatCd" },
        { cells: [{ header: "L_PRCSS_STAT", binding: "asnmtOfcrTpCd", width: "*" }], id: "asnmtOfcrTpCd" },
        { cells: [{ header: "L_PRCS_DT", binding: "prcssDtm", width: "*" }], id: "prcssDtm" },
        { colspan: 2, cells: [{ header: "L_CNNT", binding: "cnnt", width: "*", colspan: 2 }], id: "cnnt" },
    ],

    body: [
        {
            cells: [{ binding: "orgNm", type: "text", align: "left", rowspan: 2 }],
        },
        {
            cells: [
                {
                    binding: "prcssStatCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0131",
                    align: "center",
                    rowspan: 2,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    align: "center",
                    rowspan: 2,
                },
            ],
        },
        {
            cells: [{ binding: "prcssDtm", type: "datetime", align: "center", rowspan: 2 }],
        },
        {
            colspan: 2,
            cells: [
                { binding: "prcssRsnNm", type: "text", align: "left" },
                { binding: "prcssCn", type: "text", align: "left" },
                { binding: "aprvRmrk", type: "text", align: "left" },
                { binding: "rmrk", type: "text", align: "left" },
            ],
        },
    ],
};
